import {
  Box,
  Button,
  Center,
  PasswordInput,
  Text,
  TextInput,
  Title,
  createStyles,
} from "@mantine/core";
import { Form, useMedplum } from "@medplum/react";
import { useCallback, useState } from "react";
import { LoginAuthenticationResponse, normalizeErrorString } from "@medplum/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import Logo from '../../assets/img/healthConnectLogo1.svg'
import BrandingPageLayout from "../../components/BrandingPageLayout";

const useStyles = createStyles(() => ({
  appLogo: {
      marginBottom:'24px'
  },
}));

export function SignInPage(): JSX.Element {
  const medplum = useMedplum();
  const navigate = useNavigate();
  const { classes } = useStyles();
  const [searchParams] = useSearchParams();
  const [outcome, setOutcome] = useState<any>();
  const [memberships, setMemberships] = useState<any[]>();


   
   
  const onSuccess = useCallback(() => {
    const nextUrl = searchParams.get('next');
    // navigate(nextUrl?.startsWith('/') ? nextUrl : '/');
    navigate("/admin/integration")
  }, [searchParams, navigate]);

  const handleCode = useCallback(
    (code: string): void => {
        medplum
          .processCode(code)
          .then(() => {
            if (onSuccess) {
              onSuccess();
            }
          })
          .catch((err) => showNotification({ color: 'red', message: normalizeErrorString(err) }));
      },
    [medplum, onSuccess]
  );

  const handleAuthResponse = useCallback(
    (response: LoginAuthenticationResponse): void => {
      if (response.memberships) {
        setMemberships(response.memberships);
      }
      if (response.code) {
          handleCode(response.code as string);
        }
    },
    [handleCode]
  );

  const handleSubmit = useCallback(
    (formData: Record<string, string>) => {
      medplum
        .startLogin({
          email: formData.email,
          password: formData.password,
          remember: formData.remember === 'on',
          scope: "offline"
        })
        .then(handleAuthResponse)
        .catch((err) => showNotification({ color: 'red', message: normalizeErrorString(err) }));
    },
    []
    
  );
   

  return (
    <BrandingPageLayout>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          margin: "0 auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "white",
        }}
      >
        <Form
          style={{
            padding: "20px",
            borderRadius: "10px",
            border: "1px solid var(--Gray-50, #EDEDED);",
            background: "#FFF",
            width: "486px",
          }}
          onSubmit={handleSubmit}
        >
          <Center>
            <img src={Logo} className={classes.appLogo} />
          </Center>
          <Center>
            <Title
              order={1}
              style={{
                fontFamily: "'Montserrat', sans-serif', sans-serif",
                fontSize: "22px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "30px",
              }}
            >
              Welcome!
            </Title>
          </Center>
          <Text
            align="center"
            size="xl"
            sx={{
              marginBottom: "48px",
              fontFamily: "'Montserrat', sans-serif', sans-serif",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "28px",
            }}
          >
            Please Sign In to continue
          </Text>
          <TextInput
            name="email"
            type="email"
            label="Email"
            placeholder="Enter Email"
            required={true}
            autoFocus={true}
          />
          <PasswordInput
            name="password"
            label="Password"
            autoComplete="off"
            required={true}
            autoFocus={true}
            placeholder="Enter Password"
            // error={getErrorsForInput(outcome, 'password')}
            sx={{
              marginTop: "24px",
              marginBottom: "24px",
            }}
          />
          {/* <Text sx={{
          textAlign: 'right',
          textDecoration: 'underline'
        }}>Forgot password ?</Text> */}

          <Button
            type="submit"
            sx={{
              width: "100%",
              marginTop: "40px",
              marginBottom: "48px",
              backgroundColor: "#1B75BC",
            }}
          >
            Sign in
          </Button>
          <Text
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "20px",
              textDecoration: "underline",
            }}
          >
            Privacy Policy & Terms of Services
          </Text>
        </Form>
      </Box>
    </BrandingPageLayout>
  );
}
